import { Component, OnInit, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { InscricaoService } from '../shared/inscricao.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { WindowService } from 'app/shared/window.service';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';

import { DadosVestibular, InscricaoResponse } from 'models/dados-vestibular';
import { environment } from 'environments/environment';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './sobre-prova.component.html',
  styleUrls: ['./sobre-prova.component.scss'],
  animations: [routerTransition],
})
export class SobreProvaComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  data: any = {};
  canhoto = false;
  pne = false;
  tipoPne: any = '';
  siglaVestibular: String = '';
  dadosVestibular: DadosVestibular;

  linkEdital = '';
  loading = true;
  dadosVestibularSubscription: Subscription;
  environment = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private incricaoService: InscricaoService,
    private fluxoVestibularService: FluxoVestibularService,
    private blockingSpinnerService: BlockingSpinnerService,
    private windowService: WindowService,
    private analytics: AnalyticsService,
  ) { }

  ngOnInit() {
    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();

    if (!this.dadosVestibular.vestibular) {
      this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(() => {
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.dadosVestibularSubscription.unsubscribe();
        this.init();
      });

    } else {
      this.init();
      this.analytics.registrar(
        `Vestibular`,
        `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
        'Agendamento',
      );
    }
  }

  init() {
    if (this.dadosVestibular && this.dadosVestibular.agendamento) {
      this.data = this.dadosVestibular.agendamento.data;
      this.canhoto = this.dadosVestibular.agendamento.canhoto;
      this.pne = this.dadosVestibular.agendamento.pne;
      this.tipoPne = this.dadosVestibular.agendamento.tipoPne;
    }

    if (this.dadosVestibular) {
      this.siglaVestibular = this.dadosVestibular.vestibular.sigla;
    }

    // link para edital
    this.linkEdital = this.windowService.nativeWindow.location.origin + '/novoportal/vestibular/editais-manuais';

    const date = new Date(this.dadosVestibular.vestibular.dataVestibular);
    //console.log(date);
    //console.log(this.dadosVestibular.vestibular.dataVestibular);
    const weekday = this.getWeekDay(date);
    const fullParts = date.toLocaleString('pt').split(' ');
    const dateParts = fullParts[0].split('/');
    const data = `${dateParts[0]}/${dateParts[1]}`;
    const horaIniParts = fullParts[1].split(':');
    const horaInicio = `${horaIniParts[0]}:${horaIniParts[1]}`;

    this.data = {
      date: date,
      descricaoFull: `${weekday}, ${data} às ${horaInicio}`,
      descricaoDisplay: `${weekday}, ${data} às ${horaInicio}`,
      descricao: `${data} ${(this.dadosVestibular.vestibular.sigla=='ME'||this.dadosVestibular.vestibular.sigla=='MN')?``: ` às ${horaInicio}`}`,
    };

    this.loading = false;
  }

  disableBtnAgendar() {
    if(this.siglaVestibular!=="MN" && this.siglaVestibular !=='TE'){
      if (this.pne && this.tipoPne === '') {
        return true;
      }
    }
  }

  agendar() {
    //console.log(this.data);
    this.blockingSpinnerService.show();
    if(this.siglaVestibular!=="MN"){
      this.fluxoVestibularService.setDadosVestibular({
        agendamento: {
          data: this.data,
          canhoto: this.canhoto,
          pne: this.pne,
          tipoPne: this.tipoPne,
        },
      });
    }else{
      this.fluxoVestibularService.setDadosVestibular({
        agendamento: {
          data: this.data,
          canhoto: false,
          pne: null,
          tipoPne: '',
        },
      });
    }


    this.incricaoService.inscrever(this.fluxoVestibularService.getDadosVestibular()).then(
      (data: InscricaoResponse) => {
        this.fluxoVestibularService.proximoPasso({
          agendamento: {
            data: this.data,
            canhoto: this.canhoto,
            pne: this.pne,
            tipoPne: this.tipoPne,
            numeroInscricao: data.numeroInscricao,
          },
        });
        console.log("próxima rota")
        const proximaRota = this.fluxoVestibularService.proximaRota();
        this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
        this.blockingSpinnerService.close();
      },
      resp => {
        console.error(resp.erro.mensagem);
        this.blockingSpinnerService.close();
      },
    );
  }

  getWeekDay(date) {
    const weekdays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
    const dayOfWeek = date ? date.getDay() : NaN;
    return isNaN(dayOfWeek) ? null : weekdays[dayOfWeek];
  }

}
